import { render, staticRenderFns } from "./PaginationPages.vue?vue&type=template&id=cfc8f5d0"
import script from "./PaginationPages.vue?vue&type=script&lang=js"
export * from "./PaginationPages.vue?vue&type=script&lang=js"
import style0 from "./PaginationPages.vue?vue&type=style&index=0&id=cfc8f5d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports